import { createRouter, createWebHashHistory } from 'vue-router'
import Loading from 'quasar/src/plugins/Loading.js';
import store from '@/store'
import routes from './routes'

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.afterEach(() => {
  Loading.hide()
})

router.beforeEach((to, from, next) => {
  if ((!to.meta.auth) || (store.getters.getUsuarioLogado)) {
       if (to.meta.possuiNivel) {
          Loading.show()
          next()
       } else {
        next({ path: '/login' })
       }
  } else {
      next({ path: '/login' })
  }
})

export default router
